// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:34:49.224Z
// Property: Mulberry at Rice Hope (ID: 6767906449167579)
// Collections: 17 amenities, 6 floorplans (live), 22 photos, 38 POIs, 2 reviews, 6 virtual tours, 5 office hours, 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167579",
  "property_external_id": "1661776",
  "property_zillow_url": "https://www.zillow.com/b/mulberry-at-rice-hope-pt-wentworth-ga-CjTHrX/",
  "property_apartments_url": "https://www.apartments.com/35-weavers-way-port-wentworth-ga/cl94hle/",
  "property_google_business_url": "https://www.google.com/maps/place/Mulberry+at+Rice+Hope/@32.2229303,-81.1897049,837m/data=!3m1!1e3!4m6!3m5!1s0x88fba36c3ff9db83:0xc8c53c93030e962c!8m2!3d32.2229099!4d-81.187146!16s%2Fg%2F11hk6vq0_n?entry=ttu&g_ep=EgoyMDI2MDkyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57160263277",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mulberry-at-rice-hope",
  "property_name": "Mulberry at Rice Hope",
  "property_website_url": "https://www.mulberryatricehope.com/",
  "property_domain": "https://www.mulberryatricehope.com/",
  "property_address": "5 Weavers Way",
  "property_full_address": "5 Weavers Way, Port Wentworth, GA 31407",
  "property_address_1": "5 Weavers Way",
  "property_address_2": null,
  "property_address_city": "Port Wentworth",
  "property_address_state": "GA",
  "property_address_zip_full": "31407",
  "property_address_zip": "31407",
  "property_address_country": "US",
  "property_address_county": "Chatham County",
  "property_neighborhood_address": "Rice Hope master-planned community",
  "property_address_latitude": "32.222827",
  "property_address_longitude": "-81.187162",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(478) 377-5659",
  "property_call_tracking_phone": "478-377-5659",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>Detached-home living meets resort-level ease.</strong> Mulberry at Rice Hope offers spacious three- and four-bedroom homes with smart features, polished finishes, lawn service, and access to trails, green space, and standout community amenities in a master-planned Port Wentworth setting.</p>",
  "property_long_description": "<p><strong>Detached-home living with resort-level Rice Hope amenities.</strong> At Mulberry at Rice Hope, you get the space and feel of a three- or four-bedroom single-family home in a master-planned Port Wentworth setting surrounded by protected woods, wetlands, tree-lined sidewalks, and trails around Indigo Lake. Choose from spacious layouts with smart home technology, stainless steel appliances, granite countertops, luxury flooring, in-unit laundry, and lawn service that keeps everyday upkeep simple.</p><p>Step outside for a <a href=\"/amenities\">resort-style pool and lazy river</a>, clubhouse fitness center, playgrounds, dog park, fire pit, amphitheater, fishing, kayaking, and green space woven through the community. When you are headed out, Rice Hope places you just off I-95 near Highway 21, with Publix close by, Pooler shopping and dining—including Tanger Outlets—nearby, and convenient access to Savannah/Hilton Head International Airport, Gulfstream, the Port of Savannah, and historic downtown Savannah. Explore <a href=\"/floor-plans\">three- and four-bedroom floor plans</a> designed for modern coastal Georgia living.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-0db8-74fe-b276-c5bbed24aa3f.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a modern single-family home with a gray exterior, white garage door, and a manicured lawn.",
    "public_id": "019fbe45-0db8-74fe-b276-c5bbed24aa3f",
    "storage_key": "property/6767906449167579/019fbe45-0db8-74fe-b276-c5bbed24aa3f.webp",
    "width": 1280,
    "height": 900
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167579/01a0c018-2a89-71fc-bc85-9fff17e8e343.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c018-2a89-71fc-bc85-9fff17e8e343",
    "storage_key": "property/6767906449167579/01a0c018-2a89-71fc-bc85-9fff17e8e343.mp4",
    "thumbnail_key": "property/6767906449167579/01a0c018-2a89-71fc-bc85-9fff17e8e343_thumb.webp",
    "size_bytes": 10991703,
    "classification": "Community",
    "title": "Explore Our Apartment Community and Amenities",
    "description": "Discover our vibrant apartment community featuring a resort-style pool, water slides, splash pad, and extensive grounds. Perfect for families and individuals seeking a modern lifestyle."
  },
  "property_total_units": "95",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "21",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, landscaping $95, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval from Quinn Property Management. Pet screening is required before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening is required before move-in.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://mulberryatricehope.securecafe.com/onlineleasing/mulberry-at-rice-hope/floorplans.aspx",
  "property_resident_portal_url": "https://mulberryatricehope.securecafenet.com/residentservices/mulberry-at-rice-hope/userlogin",
  "property_apply_now_url": "https://mulberryatricehope.securecafe.com/onlineleasing/mulberry-at-rice-hope/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/01a0d032-0f35-7488-9436-c6e83ec35856.webp",
  "property_primary_logo_media": {
    "alt_text": "Mulberry at Rice Hope logo",
    "public_id": "01a0d032-0f35-7488-9436-c6e83ec35856",
    "storage_key": "property/6767906449167579/01a0d032-0f35-7488-9436-c6e83ec35856.webp",
    "width": 97,
    "height": 64
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/01a0d040-4359-743a-bf10-de46273d6da7.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0d040-4359-743a-bf10-de46273d6da7",
    "storage_key": "property/6767906449167579/01a0d040-4359-743a-bf10-de46273d6da7.webp",
    "width": 97,
    "height": 64
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/01a0d040-37de-759d-b121-56aa70ef9f06.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0d040-37de-759d-b121-56aa70ef9f06",
    "storage_key": "property/6767906449167579/01a0d040-37de-759d-b121-56aa70ef9f06.webp",
    "width": 97,
    "height": 64
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#637e37",
  "property_secondary_color": "#522f32",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2 - 2.5",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "3",
  "property_sqft_range": "1548 - 2200",
  "property_sqft_min": "1548",
  "property_sqft_max": "2443",
  "property_price_range": "2336 - 2994",
  "property_price_min": "2213",
  "property_price_max": "2489",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/101139232482094",
  "property_instagram_url": "https://www.instagram.com/mulberryatricehope/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJg9v5P2yj-4gRLJYOA5M8xcg",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Mulberry at Rice Hope",
  "property_home_romance_title": "Your Heart's Home Awaits You Here",
  "property_home_amenities_blurb": "<p><strong>Detached-home comfort meets resort-style downtime.</strong> At Mulberry at Rice Hope, everyday living comes with standout spaces to unwind, recharge, and get more done—from a lazy river and resort-style pool to a clubhouse fitness center in the Port Wentworth Rice Hope setting.</p><p>Inside, stainless steel appliances, granite countertops, luxury flooring, smart home technology, in-unit laundry, and spacious closets add polish and ease, while lawn service keeps the routine simple.</p>",
  "property_home_floorplans_blurb": "<p><strong>Detached space, thoughtfully planned.</strong> Explore newly built three- and four-bedroom homes in Port Wentworth with open gathering areas, separated bedrooms, generous storage, and everyday upgrades like in-unit laundry, smart home touches, stainless steel appliances, granite countertops, and luxury flooring. Compare available layouts and find the home that fits your next move.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Mulberry at Rice Hope.</strong> Preview bright, detached three- and four-bedroom homes with open kitchens, granite countertops, stainless steel appliances, airy living spaces, and polished smart details. Then follow the view outside to sunlit pool scenes, a winding lazy river, clubhouse fitness spaces, green lawns, and community paths that capture the easygoing coastal feel of Port Wentworth.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Easy starts here.</strong> Mulberry at Rice Hope keeps daily essentials close with The Market at Rice Hope nearby, lakeside paths around Indigo Lake, and quick I-95 access to Pooler shopping, dining, movies, and Tanger Outlets. When the day calls for more, Savannah’s squares, River Street, museums, and waterfront dining are an easy drive from this relaxed Port Wentworth setting.</p>",
  "property_home_reviews_blurb": "<p><strong>Service that gets noticed.</strong> Resident reviews for Mulberry at Rice Hope often spotlight the team by name, with praise for attentive help, clear communication, and a friendly, professional approach.</p><p>From Cody and his team to Kaily, Gabriel, and Blake, reviewers describe a community experience that feels cared for—along with comfortable homes and everyday connection with neighbors. Read the reviews to see what stands out most.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your map to easy.</strong> From Mulberry at Rice Hope, everyday stops and weekend detours are close without giving up the calm of a lakeside master-planned setting. Pick up groceries at The Market at Rice Hope, follow paths around Indigo Lake, or head out via I-95 for Pooler’s shopping, movies, and dining along Tanger Outlets and Pooler Parkway.</p><p>When you want a bigger change of scene, Savannah is an easy drive for cobblestone squares, River Street views, museums, restaurants, and waterfront nights out. Closer to home, Port Wentworth keeps the pace relaxed with neighborhood greenspace, coastal Georgia scenery, and access to the Savannah National Wildlife Refuge. Explore the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, without giving up the feel of home.</strong> At Mulberry at Rice Hope, your day can move from coffee in a spacious, detached home to a float on the lazy river, a swim at the resort-style pool, or a workout in the clubhouse gym—all within the Rice Hope setting in Port Wentworth.</p><p>Inside, polished finishes keep the focus on comfort and ease: stainless steel appliances, granite countertops, luxury flooring, smart home technology, in-unit laundry, and closets with room to stay organized. Lawn service helps simplify the routine, so the community spaces feel less like a bonus and more like part of everyday life. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready for detached-home living with less upkeep?</strong> Mulberry at Rice Hope brings three- and four-bedroom space, smart home features, modern finishes, in-unit laundry, and lawn service together in a master-planned Port Wentworth setting. Start your online application today and take the next step toward calling Mulberry home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the Mulberry at Rice Hope leasing team for details on detached three- and four-bedroom home layouts, smart finishes, lawn service, and Rice Hope amenities—or reach out for directions to our Port Wentworth community just off I-95.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Mulberry at Rice Hope?</strong> Start here for quick answers on the community, leasing, <a href=\"/floor-plans\">three- and four-bedroom floor plans</a>, home features, and everyday living in this Port Wentworth setting. If you need more detail, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the space that fits how you live.</strong> Mulberry at Rice Hope’s floor plans trade the apartment-building feel for newly built, detached three- and four-bedroom homes in Port Wentworth, with layouts that give you real separation between bedrooms, gathering areas, storage, and everyday essentials.</p><p>Compare options with open living spaces, multiple baths in select plans, spacious closets, in-unit laundry, smart home touches, stainless steel appliances, granite countertops, and luxury flooring—then choose the plan that matches your need for extra rooms, easier hosting, or a quieter work-from-home setup. Browse current pricing and availability below, explore the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to walk your favorite layout.</p>",
  "property_gallery_blurb": "<p><strong>See the Rice Hope lifestyle in focus.</strong> Browse photos of Mulberry at Rice Hope and picture your day unfolding in bright, detached three- and four-bedroom homes, where open kitchens show off granite countertops and stainless steel appliances, living areas feel airy and polished, and smart details keep the look clean.</p><p>Then move outside through the gallery: sunlit pool scenes, the winding lazy river, clubhouse fitness spaces, green lawns, and community paths that give this Port Wentworth setting its easygoing coastal feel. Like what you see? Explore <a href=\"/virtual-tours\">virtual tours</a> for a closer look, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Mulberry at Rice Hope on the map.</strong><br>Find available three- and four-bedroom homes, then see how protected woods, wetlands, Indigo Lake trails, I-95 access, Pooler shopping, and downtown Savannah connect around this master-planned Port Wentworth setting.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, paths for every outing.</strong> At Mulberry at Rice Hope, pet-friendly living feels built into the rhythm of your day—not tacked on. Start with the freedom of a detached home, where in-unit laundry helps with muddy-towel cleanup and lawn service keeps outdoor upkeep simple. Then head out for fresh air along tree-lined sidewalks, walking trails, community green space, and the Rice Hope dog park.</p><p>In Port Wentworth, everyday pet care is easy to plan, with a nearby animal hospital for routine visits and boarding needs. Browse the <a href=\"/gallery\">photo gallery</a> to picture the community setting, then <a href=\"/schedule-a-tour\">schedule a tour</a> to show your four-legged roommate around.</p>",
  "property_referafriend_blurb": "<p><strong>Share detached-home living at Mulberry at Rice Hope.</strong> Invite a friend to discover spacious three- and four-bedroom layouts, smart home features, lawn service, and resort-level <a href=\"/amenities\">community amenities</a> in a scenic Port Wentworth setting.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made simple.</strong><br>Pay rent, submit maintenance requests, and manage your Mulberry at Rice Hope account in one convenient place—so everyday details stay as easy as lawn service and detached-home living in this master-planned Port Wentworth community.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong> Reviews for Mulberry at Rice Hope highlight the people behind the experience: attentive service, generous communication, and a team that takes time to help you feel informed.</p><p>Residents call out team members by name—from Cody and his team to Kaily, Gabriel, and Blake—with praise like “Loved the staff” and “professional, friendly, upfront and communicative.” You’ll also see residents describing comfort in their home, connection with neighbors, and appreciation for a community experience that feels cared for day to day.</p>",
  "property_created_at": "1785594460108",
  "property_scheduletour_blurb": "<p><strong>See detached-home living in person.</strong> Tour Mulberry at Rice Hope and get a closer look at spacious three- and four-bedroom layouts, smart home features, refined finishes, and the resort-level community setting that makes everyday upkeep feel simple. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture detached-home living with three- and four-bedroom space, smart finishes, lawn service, and resort-level Rice Hope amenities woven into a Port Wentworth setting of protected woods, sidewalks, trails, and lake views.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Mulberry at Rice Hope",
  "property_seo_title_home": "Mulberry at Rice Hope |  Apartments in Port Wentworth, GA",
  "property_seo_description_home": "Experience modern living at Mulberry at Rice Hope in Port Wentworth, GA. Enjoy spacious layouts, luxury amenities, and a resort-style pool!",
  "property_seo_title_floorplans": "Floor Plans | Port Wentworth, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Mulberry at Rice Hope in Port Wentworth, GA! Choose from spacious three and four-bedroom floor plans designed for modern living.",
  "property_seo_title_amenities": "Amenities | Port Wentworth, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at Mulberry at Rice Hope, Port Wentworth! Enjoy a resort-style pool, smart home tech, and spacious layouts with stainless steel appliances.",
  "property_seo_title_gallery": "Gallery | Apartments in Port Wentworth, GA",
  "property_seo_description_gallery": "Experience resort-style living at Mulberry at Rice Hope in Port Wentworth, GA, featuring luxury finishes and smart home tech. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Mulberry at Rice Hope Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Mulberry at Rice Hope in Port Wentworth, GA. Take a virtual tour of our spacious three- and four-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Mulberry at Rice Hope Apartments",
  "property_seo_description_interactivemap": "Welcome to Mulberry at Rice Hope in Port Wentworth, GA! Navigate our interactive map for spacious four and three-bedroom apartments with luxury amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Port Wentworth, GA",
  "property_seo_description_neighborhood": "Uncover the charm of Port Wentworth at Mulberry at Rice Hope. Immerse in vibrant local favorites and hidden gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Mulberry at Rice Hope",
  "property_seo_description_contact": "Reach out to Mulberry at Rice Hope in Port Wentworth, GA! Our leasing team is ready to help you find your perfect four or three-bedroom home.",
  "property_seo_title_faqs": "FAQs | Apartments in Port Wentworth, GA",
  "property_seo_description_faqs": "Find answers to your questions at Mulberry at Rice Hope in Port Wentworth, GA. Discover luxury living with top-notch amenities and spacious floor plans.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Port Wentworth, GA",
  "property_seo_description_reviews": "Experience life at Mulberry at Rice Hope in Port Wentworth, GA. Check out resident reviews and see why our luxury amenities and spacious layouts shine!",
  "property_seo_title_applynow": "Apply Now | Apartments in Port Wentworth, GA",
  "property_seo_description_applynow": "Discover modern comfort at Mulberry at Rice Hope in Port Wentworth, GA. Enjoy luxury amenities and spacious floor plans—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Mulberry at Rice Hope",
  "property_seo_description_residentaccess": "Log in to your Mulberry at Rice Hope resident portal for seamless rent payments, maintenance requests, and community updates in beautiful Port Wentworth, GA!",
  "property_seo_title_referafriend": "Refer A Friend | Mulberry at Rice Hope",
  "property_seo_description_referafriend": "Refer a friend to Mulberry at Rice Hope in Port Wentworth, GA! Great friends make even better neighbors—share the joy of vibrant living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Mulberry at Rice Hope",
  "property_seo_description_scheduletour": "Experience the charm of Mulberry at Rice Hope in Port Wentworth, GA. Schedule your tour today to see your future home in this inviting community!",
  "property_seo_title_privacy": "Privacy Policy | Mulberry at Rice Hope",
  "property_seo_description_privacy": "At Mulberry at Rice Hope in Port Wentworth, GA, your privacy matters. Review our privacy policy to understand how we protect your information with care.",
  "property_seo_title_accessibility": "Website Accessibility | Mulberry at Rice Hope",
  "property_seo_description_accessibility": "At Mulberry at Rice Hope, we prioritize digital inclusion in Port Wentworth, GA. Join us in fostering accessibility for everyone—your home awaits!",
  "property_seo_title_sitemap": "Sitemap | Mulberry at Rice Hope",
  "property_seo_description_sitemap": "Navigate your way through Mulberry at Rice Hope's sitemap! Find your ideal Port Wentworth apartment and uncover community features that await you.",
  "property_seo_title_thankyou": "Thank You | Mulberry at Rice Hope",
  "property_seo_description_thankyou": "Thank you for contacting Mulberry at Rice Hope! We'll be in touch soon about your future home in Port Wentworth.",
  "property_seo_title_pets": "Pet Policy | Apartments in Port Wentworth, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793286840588",
  "amenities": [
    {
      "id": "ec_9c772ce7627a71aa04817a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615846",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4230e68a8679a707e6320f05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615847",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bef7111ab8592803fdc7c949",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615845",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_506f3729d7a748c8ca8b0f20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615844",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4364609e04a735269d6839ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "129124652",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26e522208e146f96491dec6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "129124641",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76ad248b20dabc976c8b3207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615858",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_792939027a6104555d86f0a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615856",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a95f3fb89866f4200480cbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615855",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34e89257934f22baa359cb06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615850",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9411bd653249abc9ed0aadb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615851",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf01649766d6dc67a3660599",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615853",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f28f6002cc40b6d5c28a09fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615854",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c646bfd72479fbb85da0807",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "122615868",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa9831aba281b1a4e06959a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "129124624",
      "title": "Lazy River Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5921bb063ea6e8836517a7fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "129124634",
      "title": "Spacious Garages",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bedaaf8a95b22a32e64b5ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "129124638",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_15e5ad668fe1e8194cf1f829",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-0db8-74fe-b276-c5bbed24aa3f.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern single-family home with a gray exterior, white garage door, and a manicured lawn.",
        "public_id": "019fbe45-0db8-74fe-b276-c5bbed24aa3f",
        "storage_key": "property/6767906449167579/019fbe45-0db8-74fe-b276-c5bbed24aa3f.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Charming single-family home featuring a modern gray exterior, a spacious white garage door, and a well-maintained lawn. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "A two-story house with a garage and a driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Durham-Exterior.jpg"
    },
    {
      "id": "ec_b2d6a3cbf5f2dbdde5b3268b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-10d0-741c-b235-f61dea2930b3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
        "public_id": "019fbe45-10d0-741c-b235-f61dea2930b3",
        "storage_key": "property/6767906449167579/019fbe45-10d0-741c-b235-f61dea2930b3.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, granite countertops, and ample white cabinetry for storage.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite counter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Guilford-Kitchen.jpg"
    },
    {
      "id": "ec_061dbd45f42c61d925324a72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-0d00-7311-b600-8c50d283f98c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019fbe45-0d00-7311-b600-8c50d283f98c",
        "storage_key": "property/6767906449167579/019fbe45-0d00-7311-b600-8c50d283f98c.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, elegant granite countertops, and a full suite of stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Durham-Kitchen.jpg"
    },
    {
      "id": "ec_50226e7a4d29d376cb56f045",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-113a-75cf-849c-f0fed4148869.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with hardwood floors and white cabinets.",
        "public_id": "019fbe45-113a-75cf-849c-f0fed4148869",
        "storage_key": "property/6767906449167579/019fbe45-113a-75cf-849c-f0fed4148869.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Experience the open-concept living space, perfect for entertaining, with a modern kitchen featuring stainless steel appliances and ample cabinet space.",
      "link": "false",
      "alt_text": "A spacious room with wooden flooring and a kitchen area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Guilford-Living-Room.jpg"
    },
    {
      "id": "ec_91fb54d14dde008608864e32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-0570-713b-b5b9-6cf5fc9bcf97.webp",
      "image_media": {
        "alt_text": "Exterior view of a light gray two-story house with a white garage door and dark blue shutters.",
        "public_id": "019fbe45-0570-713b-b5b9-6cf5fc9bcf97",
        "storage_key": "property/6767906449167579/019fbe45-0570-713b-b5b9-6cf5fc9bcf97.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Charming exterior view of a two-story home featuring light gray siding, a prominent white garage door, and elegant dark blue shutters, offering a welcoming curb appeal.",
      "link": "false",
      "alt_text": "A modern house with a grey exterior and a white garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Chatham-Exterior.jpg"
    },
    {
      "id": "ec_19d1124fb69884377f5a5c99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-10fe-7657-bbf2-dd7fb36267b9.webp",
      "image_media": {
        "alt_text": "Front exterior of a two-story blue and white house with a garage and front porch.",
        "public_id": "019fbe45-10fe-7657-bbf2-dd7fb36267b9",
        "storage_key": "property/6767906449167579/019fbe45-10fe-7657-bbf2-dd7fb36267b9.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming two-story home with a welcoming front porch and a spacious two-car garage. Features a blue upper level with white siding below and brick accents.",
      "link": "false",
      "alt_text": "A two-story house with a blue and white exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Guilford-Exterior.jpg"
    },
    {
      "id": "ec_eda269c05f7178975702672b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-ebfc-770f-a3df-2de5bfbc3edb.webp",
      "image_media": {
        "alt_text": "Aerial view of a new housing development with townhomes and single-family houses.",
        "public_id": "019fbe44-ebfc-770f-a3df-2de5bfbc3edb",
        "storage_key": "property/6767906449167579/019fbe44-ebfc-770f-a3df-2de5bfbc3edb.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "An aerial view showcases a developing neighborhood featuring a mix of modern townhomes and single-family residences, complete with manicured lawns and streets.",
      "link": "false",
      "alt_text": "A row of houses with a lake in the front yard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Community-Aeria-3.jpg"
    },
    {
      "id": "ec_e4b50ff068544066e5dee1ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-fa5a-746f-8f79-a51c66f8bb68.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with townhouses and single-family homes.",
        "public_id": "019fbe44-fa5a-746f-8f79-a51c66f8bb68",
        "storage_key": "property/6767906449167579/019fbe44-fa5a-746f-8f79-a51c66f8bb68.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Discover a vibrant community featuring a mix of modern townhouses and charming single-family homes, set against a backdrop of lush greenery.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential area with houses and cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Community-Aeria-2l.jpg"
    },
    {
      "id": "ec_9c612bb49642d3a718979367",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-fb5b-7021-bfad-5586c54bbb17.webp",
      "image_media": {
        "alt_text": "Aerial view of a community pool area with slides and lounge chairs, a clubhouse, a playground, and a large parking lot.",
        "public_id": "019fbe44-fb5b-7021-bfad-5586c54bbb17",
        "storage_key": "property/6767906449167579/019fbe44-fb5b-7021-bfad-5586c54bbb17.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Experience resort-style living with our expansive pool area, complete with water slides, a lazy river, and ample seating. Enjoy our state-of-the-art fitness center, playground, and beautifully landscaped grounds.",
      "link": "false",
      "alt_text": "A large open grassy area with a parking lot and a pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Amenity-Aerial.jpg"
    },
    {
      "id": "ec_f244983d4bbb8fc12357ee1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-fa1f-7048-86b0-056724fd0862.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, exercise bikes, and weight equipment.",
        "public_id": "019fbe44-fa1f-7048-86b0-056724fd0862",
        "storage_key": "property/6767906449167579/019fbe44-fa1f-7048-86b0-056724fd0862.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength-training equipment for a complete workout.",
      "link": "false",
      "alt_text": "A gym with a variety of equipment including treadmills, weights, and exercise machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Community-Gym.jpg"
    },
    {
      "id": "ec_771505b5362ebbb59d081caf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-fb3b-75ee-bf51-1d642d56ed6c.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style pool complex with waterslides, lazy river, and lounge areas.",
        "public_id": "019fbe44-fb3b-75ee-bf51-1d642d56ed6c",
        "storage_key": "property/6767906449167579/019fbe44-fb3b-75ee-bf51-1d642d56ed6c.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Experience luxury resort living with our expansive pool complex, featuring a lap pool, lazy river, waterslides, and ample sun-drenched lounge areas for relaxation and fun.",
      "link": "false",
      "alt_text": "An aerial view of a resort with a large swimming pool and a water slide.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Community-Aeria-4.jpg"
    },
    {
      "id": "ec_1a430f185aa0797ec7e7300a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-f9ac-75eb-9e8a-2cb552a301b3.webp",
      "image_media": {
        "alt_text": "Exterior of a single-family home with a white siding and a two-car garage.",
        "public_id": "019fbe44-f9ac-75eb-9e8a-2cb552a301b3",
        "storage_key": "property/6767906449167579/019fbe44-f9ac-75eb-9e8a-2cb552a301b3.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Charming single-family home featuring crisp white siding and a spacious two-car garage, perfect for any family.",
      "link": "false",
      "alt_text": "A white house with a black door and a grey roof.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Brunswick-Exterior.jpg"
    },
    {
      "id": "ec_bb15b21988e6b9243212e7c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-0328-706e-bf19-5644ad287b13.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019fbe45-0328-706e-bf19-5644ad287b13",
        "storage_key": "property/6767906449167579/019fbe45-0328-706e-bf19-5644ad287b13.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Perfect for home chefs and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a black stove top oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Brunswick-Kitchen.jpg"
    },
    {
      "id": "ec_16059e3360995c2197eb1e62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-039f-7387-8535-e97dae5e7e72.webp",
      "image_media": {
        "alt_text": "Spacious open-concept living area and kitchen with island, dark wood-look flooring.",
        "public_id": "019fbe45-039f-7387-8535-e97dae5e7e72",
        "storage_key": "property/6767906449167579/019fbe45-039f-7387-8535-e97dae5e7e72.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Experience the expansive feel of this open-concept living area, perfect for entertaining, seamlessly flowing into a modern kitchen with a central island.",
      "link": "false",
      "alt_text": "A large empty room with wooden floors and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Brunswick-Living-Room.jpg"
    },
    {
      "id": "ec_84ad0fc6706e9c8bac3a8efd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-0681-71bb-804b-b89a946a7446.webp",
      "image_media": {
        "alt_text": "Open concept living room and kitchen with island, stainless steel appliances, and ample natural light.",
        "public_id": "019fbe45-0681-71bb-804b-b89a946a7446",
        "storage_key": "property/6767906449167579/019fbe45-0681-71bb-804b-b89a946a7446.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Experience modern living in this spacious open-concept apartment, featuring a sleek kitchen with an island, stainless steel appliances, and abundant natural light.",
      "link": "false",
      "alt_text": "A spacious room with wooden flooring and a kitchen area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Chatham-Living-Room.jpg"
    },
    {
      "id": "ec_eb697067e867f54acd5a07cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-079a-73d2-96be-5279aa90de18.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen with white cabinets, stainless steel appliances, and hardwood floors.",
        "public_id": "019fbe45-079a-73d2-96be-5279aa90de18",
        "storage_key": "property/6767906449167579/019fbe45-079a-73d2-96be-5279aa90de18.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Experience the open-concept design of our apartments, featuring a modern kitchen with ample cabinet space and a seamless flow into the living area.",
      "link": "false",
      "alt_text": "A spacious kitchen with white cabinets and a wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Durham-Living-Room.jpg"
    },
    {
      "id": "ec_480ebe839eab41e242b3bfca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-1664-7624-afb4-3e24fd4e563e.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with a white facade, black shutters, and a two-car garage. A small tree is in front of the entrance.",
        "public_id": "019fbe45-1664-7624-afb4-3e24fd4e563e",
        "storage_key": "property/6767906449167579/019fbe45-1664-7624-afb4-3e24fd4e563e.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming two-story home featuring a clean white exterior, classic black shutters, and a spacious two-car garage. The inviting entrance is shaded by a small tree, creating a welcoming curb appeal.",
      "link": "false",
      "alt_text": "A white house with a black roof and a tree in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-McDowell-Exterior.jpg"
    },
    {
      "id": "ec_c853a2174b8942a9a4dc8552",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-172b-7102-81aa-30be287b9fee.webp",
      "image_media": {
        "alt_text": "Open-concept living area with kitchen and island",
        "public_id": "019fbe45-172b-7102-81aa-30be287b9fee",
        "storage_key": "property/6767906449167579/019fbe45-172b-7102-81aa-30be287b9fee.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly connects to a modern kitchen, featuring a large island and ample counter space.",
      "link": "false",
      "alt_text": "A spacious living room with wooden flooring and a kitchen area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-McDowell-Living-Room.jpg"
    },
    {
      "id": "ec_044693adefad66796ec59452",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-19a4-7139-9db2-57dce43f2863.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019fbe45-19a4-7139-9db2-57dce43f2863",
        "storage_key": "property/6767906449167579/019fbe45-19a4-7139-9db2-57dce43f2863.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample cabinet space, granite countertops, a full suite of stainless steel appliances, and a large central island perfect for meal prep and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-McDowell-Kitchen.jpg"
    },
    {
      "id": "ec_fe4eaa18ea7b5807e3aee8de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/01a188f0-ee6c-765e-b7fc-6381196a3b91.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table, sectional sofa, and modern appliances.",
        "public_id": "01a188f0-ee6c-765e-b7fc-6381196a3b91",
        "storage_key": "property/6767906449167579/01a188f0-ee6c-765e-b7fc-6381196a3b91.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a modern kitchen and dining space, perfect for entertaining.",
      "link": "false",
      "alt_text": "A living room with a grey couch and a wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Pickens-Living-Room.jpg"
    },
    {
      "id": "ec_a6a71b45b587f4f2ac55682b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/01a188f0-eef1-728a-a212-a2a1d690e468.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets.",
        "public_id": "01a188f0-eef1-728a-a212-a2a1d690e468",
        "storage_key": "property/6767906449167579/01a188f0-eef1-728a-a212-a2a1d690e468.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and granite countertops, perfect for all your culinary needs.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Pickens-Kitchen(1).jpg"
    },
    {
      "id": "ec_9edefc423da70c91b6ebd223",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/01a188f0-edf7-70d4-a9b0-119b58571314.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, soaking tub and shower, and entrance to bedroom",
        "public_id": "01a188f0-edf7-70d4-a9b0-119b58571314",
        "storage_key": "property/6767906449167579/01a188f0-edf7-70d4-a9b0-119b58571314.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Step into comfort with this spacious bathroom featuring a double vanity, a luxurious soaking tub, and a separate shower. Enjoy the convenience of direct access to the bedroom.",
      "link": "false",
      "alt_text": "A bathroom with a white tub and a white door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Mulberry-Pickens-Primary-Bathroom.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4b158d78-9353-4d2c-8638-0673c0916b43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Moe's Southwest Grill",
      "poi_type": "Restaurants",
      "poi_address": "4 Magnolia Blvd Ste 100, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Counter-serve chain dishing up Southwestern staples from burritos to nachos in lively environs.",
      "poi_long_description": "Counter-serve chain dishing up Southwestern staples from burritos to nachos in lively environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-756e-73cb-94be-f95f183f6e41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-756e-73cb-94be-f95f183f6e41",
        "storage_key": "property/6767906449167579/019fbdbb-756e-73cb-94be-f95f183f6e41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.moes.com/ga/port-wentworth/4-magnolia-blvd?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=17382697176946490694",
      "poi_item_slug": "moes-southwest-grill",
      "poi_latitude": "32.2139674",
      "poi_longitude": "-81.1985787",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-201-1833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWXZDuzaj-4gRRr0UJvy-O_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_dfa850ec-18de-4e6b-b434-d79ea8e7587b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "El Ranchito Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7306 GA-21 #201, Port Wentworth, GA 31407, USA",
      "poi_short_description": "An array of classic Mexican & American dishes & drinks in a relaxed space with cantina-style decor.",
      "poi_long_description": "An array of classic Mexican & American dishes & drinks in a relaxed space with cantina-style decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-429b-7449-aa65-11ea1c434146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdb9-429b-7449-aa65-11ea1c434146",
        "storage_key": "property/6767906449167579/019fbdb9-429b-7449-aa65-11ea1c434146.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.elranchitomexgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11327956137006368040",
      "poi_item_slug": "el-ranchito-mexican-restaurant",
      "poi_latitude": "32.2002442",
      "poi_longitude": "-81.1956003",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-965-0270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbV0jx-Wi-4gRKIV4qRb8NJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f80a7925-4e14-4086-8cbd-385e73914f41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Milan Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "7202 Augusta Rd, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Restaurant and bar with a menu featuring burgers, grilled seafood and steaks, plus cocktails.",
      "poi_long_description": "Restaurant and bar with a menu featuring burgers, grilled seafood and steaks, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-7567-750e-931b-4f1c4dc8ec35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-7567-750e-931b-4f1c4dc8ec35",
        "storage_key": "property/6767906449167579/019fbdbb-7567-750e-931b-4f1c4dc8ec35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100087332217222",
      "poi_directions_map_url": "https://maps.google.com/?cid=9865791827439926531",
      "poi_item_slug": "milan-grill--bar",
      "poi_latitude": "32.1952463",
      "poi_longitude": "-81.1952117",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-999-6291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzaG7C-j-4gRAz2CVmVV6og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_cfc9b112-a866-413c-b056-1c3831d47d24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "190 Magellan Blvd, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-75dc-73bd-bafb-4dc2770ec56b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-75dc-73bd-bafb-4dc2770ec56b",
        "storage_key": "property/6767906449167579/019fbdbb-75dc-73bd-bafb-4dc2770ec56b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/ga/port-wentworth/190-magellan-blvd/350997?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=350997&y_source=1_MTIxMTI0MDYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5971894241392053289",
      "poi_item_slug": "dunkin",
      "poi_latitude": "32.1952506",
      "poi_longitude": "-81.19726469999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-349-7882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-beb8-7478-adc7-2ae103c2312a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-beb8-7478-adc7-2ae103c2312a",
        "storage_key": "property/6767906449167579/019fbdbb-beb8-7478-adc7-2ae103c2312a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ3ffBfOai-4gRKcxfDixu4FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_afd7c0b4-04ce-4b8c-8ea8-ee5111971082",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Georgia Comfort Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "109 Traveler's Way, Savannah, GA 31407, USA",
      "poi_short_description": "Casual restaurant featuring a buffet and Southern fare, plus a full bar.",
      "poi_long_description": "Casual restaurant featuring a buffet and Southern fare, plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-40f3-75d9-8da4-2e5756d26dc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdb9-40f3-75d9-8da4-2e5756d26dc3",
        "storage_key": "property/6767906449167579/019fbdb9-40f3-75d9-8da4-2e5756d26dc3.webp",
        "width": 978,
        "height": 1280
      },
      "poi_business_url": "https://georgiacomfortkitchen.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17214460380319240903",
      "poi_item_slug": "georgia-comfort-kitchen",
      "poi_latitude": "32.1946702",
      "poi_longitude": "-81.1939112",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-421-4109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRQRMQYWj-4gRx9L2gIIM5u4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f8fff8de-7aca-428c-bb9e-b51bd9aa16fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "The Tin Fin Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6014 GA-21 Ste d, Rincon, GA 31326, USA",
      "poi_short_description": "Family-friendly seafood restaurant serving coastal Southern favorites in a casual atmosphere.",
      "poi_long_description": "Family-friendly seafood restaurant serving coastal Southern favorites in a casual atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-7136-723f-8a42-0ced5a0ea1ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-7136-723f-8a42-0ced5a0ea1ab",
        "storage_key": "property/6767906449167579/019fbdbb-7136-723f-8a42-0ced5a0ea1ab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thetinfin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7045333536845682182",
      "poi_item_slug": "the-tin-fin-restaurant",
      "poi_latitude": "32.2534304",
      "poi_longitude": "-81.2160382",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-295-5837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4-MSg928-4gRBlbVI4YNxmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_11a300a5-29ef-4090-8a55-208119284fa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Romano Southern Grill",
      "poi_type": "Restaurants",
      "poi_address": "1252 Monteith Rd, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Casual pizzeria dishing up pies, wings, and other comfort food, plus beer and wine.",
      "poi_long_description": "Casual pizzeria dishing up pies, wings, and other comfort food, plus beer and wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-7701-75fb-8b9a-f383dfd74d6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-7701-75fb-8b9a-f383dfd74d6b",
        "storage_key": "property/6767906449167579/019fbdbb-7701-75fb-8b9a-f383dfd74d6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://romanosoutherngrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9044033276772607101",
      "poi_item_slug": "romano-southern-grill",
      "poi_latitude": "32.1960949",
      "poi_longitude": "-81.25158669999999",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-777-4754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80ZC1Rmj-4gRfeTXDlncgn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c0eeca2d-d14f-439b-86c7-8952bdfc618b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Carey Hilliard's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "198 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Casual joint preparing classic American fare including hickory-smoked BBQ, fried seafood & steaks.",
      "poi_long_description": "Casual joint preparing classic American fare including hickory-smoked BBQ, fried seafood & steaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-7e0e-721d-ac99-804c0045e7c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-7e0e-721d-ac99-804c0045e7c5",
        "storage_key": "property/6767906449167579/019fbdbb-7e0e-721d-ac99-804c0045e7c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://careyhilliards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=235597526235427418",
      "poi_item_slug": "carey-hilliards-restaurant",
      "poi_latitude": "32.1422001",
      "poi_longitude": "-81.24667749999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-330-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkX6idlah-4gRWjI5rbMCRQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_1990d162-7c39-4038-8cd4-cb7a43936a06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "World of Beer",
      "poi_type": "Restaurants",
      "poi_address": "238 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Hangout featuring 500+ global beers, lots of craft drafts & tavern food in pub digs with TVs.",
      "poi_long_description": "Hangout featuring 500+ global beers, lots of craft drafts & tavern food in pub digs with TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-7f48-70f9-b203-232e2b1ac366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-7f48-70f9-b203-232e2b1ac366",
        "storage_key": "property/6767906449167579/019fbdbb-7f48-70f9-b203-232e2b1ac366.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://worldofbeer.com/Locations/Pooler",
      "poi_directions_map_url": "https://maps.google.com/?cid=13304595514630602832",
      "poi_item_slug": "world-of-beer",
      "poi_latitude": "32.1425573",
      "poi_longitude": "-81.2488126",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-348-3082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6521-727b-bfbd-94de2bf14585",
        "storage_key": "property/6767906449167579/019fbdb9-6521-727b-bfbd-94de2bf14585.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6yE2rlWh-4gRUADQOSFro7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "custom_5b8c50c2-90d6-4b09-ab96-af41b7ab825e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Publix Super Market at The Market at Rice Hope",
      "poi_type": "Shopping & Retail",
      "poi_address": "7936 GA-21, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-4120-7049-b723-2cc5dff02356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdb9-4120-7049-b723-2cc5dff02356",
        "storage_key": "property/6767906449167579/019fbdb9-4120-7049-b723-2cc5dff02356.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1256&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=18348372300419586578",
      "poi_item_slug": "publix-super-market-at-the-market-at-rice-hope",
      "poi_latitude": "32.2213716",
      "poi_longitude": "-81.1934686",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-966-5890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6554-768a-9d4f-78a87cada307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6554-768a-9d4f-78a87cada307",
        "storage_key": "property/6767906449167579/019fbdb9-6554-768a-9d4f-78a87cada307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_6wqs-i-4gRElogtWSDov4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_db508918-c9f1-4b6c-af0e-f07ff9aab620",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "EthniCity Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "6 Magnolia Blvd Line 2, Port Wentworth, GA 31407, USA",
      "poi_short_description": "International grocery market on Highway 21 in Port Wentworth.",
      "poi_long_description": "International grocery market on Highway 21 in Port Wentworth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-84ba-7777-a45c-840ce9f6d94c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-84ba-7777-a45c-840ce9f6d94c",
        "storage_key": "property/6767906449167579/019fbdbb-84ba-7777-a45c-840ce9f6d94c.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "https://portwentworthmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17289250598801090255",
      "poi_item_slug": "ethnicity-food-mart",
      "poi_latitude": "32.2135288",
      "poi_longitude": "-81.1986208",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-298-6865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-651d-75ac-88fb-82dfa304aead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-651d-75ac-88fb-82dfa304aead",
        "storage_key": "property/6767906449167579/019fbdb9-651d-75ac-88fb-82dfa304aead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJY1ULREWj-4gRz6Y_NtHB7-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_8df1242b-755a-411e-8f00-2ffaf503d307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "7306 GA-21 Ste 307, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Chain grocery outlet with prepared foods and a deli in the Waterford Shoppes.",
      "poi_long_description": "Chain grocery outlet with prepared foods and a deli in the Waterford Shoppes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-46d0-76bb-bd7d-cc3314ecf968.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdb9-46d0-76bb-bd7d-cc3314ecf968",
        "storage_key": "property/6767906449167579/019fbdb9-46d0-76bb-bd7d-cc3314ecf968.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/ga/port-wentworth/7306-hwy-21?y_source=1_NTA0NjA3NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6281121947460844078",
      "poi_item_slug": "food-lion",
      "poi_latitude": "32.1997789",
      "poi_longitude": "-81.1944424",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-963-9813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6554-768a-9d4f-78a87cada307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6554-768a-9d4f-78a87cada307",
        "storage_key": "property/6767906449167579/019fbdb9-6554-768a-9d4f-78a87cada307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPelCqO-i-4gRLjpQ5SEHK1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0630918c-10d9-43b0-911f-cc7367afbd97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Woods Seafood",
      "poi_type": "Shopping & Retail",
      "poi_address": "711 GA-30, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Fresh seafood market and eatery for locally caught fare such as crab and shrimp, plus live crabs and snow crabs.",
      "poi_long_description": "Fresh seafood market and eatery for locally caught fare such as crab and shrimp, plus live crabs and snow crabs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-70c3-7734-96cd-ed6af424f4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-70c3-7734-96cd-ed6af424f4c6",
        "storage_key": "property/6767906449167579/019fbdbb-70c3-7734-96cd-ed6af424f4c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://woodsseafoodga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6406466294648221154",
      "poi_item_slug": "woods-seafood",
      "poi_latitude": "32.191753",
      "poi_longitude": "-81.2252077",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-963-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-651d-75ac-88fb-82dfa304aead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-651d-75ac-88fb-82dfa304aead",
        "storage_key": "property/6767906449167579/019fbdb9-651d-75ac-88fb-82dfa304aead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDSdbEXyj-4gR4i0F7iZX6Fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_2569ee14-a9bb-4f83-98ea-7e34df99eb7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "7934 GA-21 Ste 100, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-528a-755e-8c3d-240fb8fe5d90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdb9-528a-755e-8c3d-240fb8fe5d90",
        "storage_key": "property/6767906449167579/019fbdb9-528a-755e-8c3d-240fb8fe5d90.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ga/port-wentworth/7934-ga-hwy-21?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15305642853460647710",
      "poi_item_slug": "great-clips",
      "poi_latitude": "32.2210074",
      "poi_longitude": "-81.1939517",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-966-9989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zFqZ-ei-4gRHp-EGxWRaNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5be9a36d-12fd-45ad-999a-b04400cfb037",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Publix Pharmacy at The Market at Rice Hope",
      "poi_type": "Health and Wellness",
      "poi_address": "7936 GA-21, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Pharmacy inside the Publix at The Market at Rice Hope, at the community entrance.",
      "poi_long_description": "Pharmacy inside the Publix at The Market at Rice Hope, at the community entrance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9ed0-7554-a863-01eb31a7072d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9ed0-7554-a863-01eb31a7072d",
        "storage_key": "property/6767906449167579/019fbdbb-9ed0-7554-a863-01eb31a7072d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=16266465327641277288",
      "poi_item_slug": "publix-pharmacy-at-the-market-at-rice-hope",
      "poi_latitude": "32.2213246",
      "poi_longitude": "-81.19350109999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-966-5895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-beb6-7664-bcd6-5405e945a557.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-beb6-7664-bcd6-5405e945a557",
        "storage_key": "property/6767906449167579/019fbdbb-beb6-7664-bcd6-5405e945a557.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4OaUjC9-4gRaDNENQgYvuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_51890452-2412-444b-b389-7e4d38bac155",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7300 GA-21, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Drugstore and pharmacy in Port Wentworth.",
      "poi_long_description": "Drugstore and pharmacy in Port Wentworth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9c94-763f-8caa-0b2faf569d11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9c94-763f-8caa-0b2faf569d11",
        "storage_key": "property/6767906449167579/019fbdbb-9c94-763f-8caa-0b2faf569d11.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/port-wentworth-ga-pharmacies/7300-ga-highway-21-port-wentworth-ga-31407/storeid=60?WT.mc_id=LS_GOOGLE_RX_60",
      "poi_directions_map_url": "https://maps.google.com/?cid=13228084831326215943",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.1992552",
      "poi_longitude": "-81.1965805",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-964-1797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-beb6-7664-bcd6-5405e945a557.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-beb6-7664-bcd6-5405e945a557",
        "storage_key": "property/6767906449167579/019fbdbb-beb6-7664-bcd6-5405e945a557.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQ99f--i-4gRB5_ulRGZk7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2c9ed244-9d89-4d37-b3dc-7213ffe327c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Effingham Family Medicine—Port Wentworth",
      "poi_type": "Health and Wellness",
      "poi_address": "7306 GA-21 #105, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Family medicine clinic, Port Wentworth office.",
      "poi_long_description": "Family medicine clinic, Port Wentworth office.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9ce5-74c8-90e8-d07aea124a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9ce5-74c8-90e8-d07aea124a86",
        "storage_key": "property/6767906449167579/019fbdbb-9ce5-74c8-90e8-d07aea124a86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.effinghamhealth.org/familymedicine",
      "poi_directions_map_url": "https://maps.google.com/?cid=6484691627444729913",
      "poi_item_slug": "effingham-family-medicineport-wentworth",
      "poi_latitude": "32.2002639",
      "poi_longitude": "-81.1958681",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-966-2575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeWIV2eWi-4gROfjKg61A_lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9796bd10-92c6-46be-bb92-457d2d9544bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Interstate Health — Port Wentworth",
      "poi_type": "Health and Wellness",
      "poi_address": "5712 GA-21 Ste 300, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Medical clinic serving Port Wentworth.",
      "poi_long_description": "Medical clinic serving Port Wentworth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9cef-74cf-b2a8-6d33c843be35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9cef-74cf-b2a8-6d33c843be35",
        "storage_key": "property/6767906449167579/019fbdbb-9cef-74cf-b2a8-6d33c843be35.webp",
        "width": 382,
        "height": 352
      },
      "poi_business_url": "https://interstatehealth.com/port-wentworth/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12995113121892038800",
      "poi_item_slug": "interstate-health--port-wentworth",
      "poi_latitude": "32.1358099",
      "poi_longitude": "-81.17300639999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-433-7866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2WIGjGh-4gRkHhkhojqV7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ff107105-e28e-4226-b065-3576043a5806",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "200 Tanger Outlets Blvd, Pooler, GA 31322, USA",
      "poi_short_description": "Gym chain with cardio and strength equipment, at Tanger Outlets in Pooler.",
      "poi_long_description": "Gym chain with cardio and strength equipment, at Tanger Outlets in Pooler.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-4a6e-748e-a2e7-d4e1a0cc8b99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdb9-4a6e-748e-a2e7-d4e1a0cc8b99",
        "storage_key": "property/6767906449167579/019fbdb9-4a6e-748e-a2e7-d4e1a0cc8b99.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/pooler-ga?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12259842723125341305",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.1337583",
      "poi_longitude": "-81.2443395",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-239-5350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_rEQQCh-4gReSwLUgC2I6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7258bc52-01ad-40a0-889e-09d780107305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Memorial Health University Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4700 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "Major hospital in Savannah with 24-hour emergency care.",
      "poi_long_description": "Major hospital in Savannah with 24-hour emergency care.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9b84-77ae-917d-5c7abc5eb800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9b84-77ae-917d-5c7abc5eb800",
        "storage_key": "property/6767906449167579/019fbdbb-9b84-77ae-917d-5c7abc5eb800.webp",
        "width": 564,
        "height": 317
      },
      "poi_business_url": "https://www.memorialhealth.com/locations/memorial-health-university-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4320841453139011030",
      "poi_item_slug": "memorial-health-university-medical-center",
      "poi_latitude": "32.0303424",
      "poi_longitude": "-81.089434",
      "poi_miles_from_property": "18.9 mi",
      "poi_walking_minutes": "7 hours 0 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 912-350-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c28e6ae1d0c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c28e6ae1d0c4",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c28e6ae1d0c4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58O7Xe51-4gR1iUiqWi29js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fba25e21-6289-4a36-a979-5affd4964816",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Rice Creek School",
      "poi_type": "Education",
      "poi_address": "100 Mulberry Ave, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Public school, Savannah-Chatham County Public School System, at the edge of Rice Hope.",
      "poi_long_description": "Public school, Savannah-Chatham County Public School System, at the edge of Rice Hope.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-8a2f-7558-84f9-26b6cde016a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-8a2f-7558-84f9-26b6cde016a0",
        "storage_key": "property/6767906449167579/019fbdbb-8a2f-7558-84f9-26b6cde016a0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://spwww.sccpss.com/schools/rc/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=829885815712771334",
      "poi_item_slug": "rice-creek-school",
      "poi_latitude": "32.2188856",
      "poi_longitude": "-81.1945661",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-395-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-654a-7718-bc8f-41c8faabecaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-654a-7718-bc8f-41c8faabecaf",
        "storage_key": "property/6767906449167579/019fbdb9-654a-7718-bc8f-41c8faabecaf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjwW18vai-4gRBu2xocBYhAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c29388e0-8bf1-43df-87bf-4738f420ddad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Little Country Day Care",
      "poi_type": "Education",
      "poi_address": "7951 GA-21, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Family-run facility for toddlers and older featuring toys, friendly teachers, and a caring staff.",
      "poi_long_description": "Family-run facility for toddlers and older featuring toys, friendly teachers, and a caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9066-705c-910c-685fa7c976d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9066-705c-910c-685fa7c976d8",
        "storage_key": "property/6767906449167579/019fbdbb-9066-705c-910c-685fa7c976d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rymaps.xyz/business/little-country-day-care-2vq7wl",
      "poi_directions_map_url": "https://maps.google.com/?cid=11763906171121224778",
      "poi_item_slug": "little-country-day-care",
      "poi_latitude": "32.2238549",
      "poi_longitude": "-81.1961477",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 912-844-0042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-654a-7718-bc8f-41c8faabecaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-654a-7718-bc8f-41c8faabecaf",
        "storage_key": "property/6767906449167579/019fbdb9-654a-7718-bc8f-41c8faabecaf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTdCHAs6i-4gRSsy0tFXKQaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_1ff6a953-f364-4379-89b3-14829e95e11a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Robert W. Groves High School",
      "poi_type": "Education",
      "poi_address": "100 Priscilla D Thomas Way D Way, Garden City, GA 31408, USA",
      "poi_short_description": "Public high school, Savannah-Chatham County Public School System (Garden City).",
      "poi_long_description": "Public high school, Savannah-Chatham County Public School System (Garden City).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-88ee-70ff-866e-ba559d0af4ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-88ee-70ff-866e-ba559d0af4ae",
        "storage_key": "property/6767906449167579/019fbdbb-88ee-70ff-866e-ba559d0af4ae.webp",
        "width": 1179,
        "height": 585
      },
      "poi_business_url": "https://spwww.sccpss.com/schools/groves/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075793630038292305",
      "poi_item_slug": "robert-w-groves-high-school",
      "poi_latitude": "32.1060698",
      "poi_longitude": "-81.1557893",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-395-2520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-654a-7718-bc8f-41c8faabecaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-654a-7718-bc8f-41c8faabecaf",
        "storage_key": "property/6767906449167579/019fbdb9-654a-7718-bc8f-41c8faabecaf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo8P8GWSf-4gRUXdnPtFEMmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_bd5f7e56-412c-4819-8e6b-116666821370",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Plant Riverside District",
      "poi_type": "Entertainment",
      "poi_address": "1036 W River St, Savannah, GA 31401, USA",
      "poi_short_description": "Riverfront entertainment district on Savannah's River Street with restaurants, shops and live music.",
      "poi_long_description": "Riverfront entertainment district on Savannah's River Street with restaurants, shops and live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-95d0-772e-a3d3-4df10e2950b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-95d0-772e-a3d3-4df10e2950b8",
        "storage_key": "property/6767906449167579/019fbdbb-95d0-772e-a3d3-4df10e2950b8.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.plantriverside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=54035275616598733",
      "poi_item_slug": "plant-riverside-district",
      "poi_latitude": "32.083876",
      "poi_longitude": "-81.096516",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 912-373-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2DzNwCf-4gRzbp3AMz4vwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_e45b17e4-fc87-49d3-be04-3fc4e604f507",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "SCAD Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "601 Turner Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Part of the Savannah College of Art & Design, this teaching museum displays modern art.",
      "poi_long_description": "Part of the Savannah College of Art & Design, this teaching museum displays modern art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9577-709f-b525-6b8fc0a9a6c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9577-709f-b525-6b8fc0a9a6c5",
        "storage_key": "property/6767906449167579/019fbdbb-9577-709f-b525-6b8fc0a9a6c5.webp",
        "width": 992,
        "height": 557
      },
      "poi_business_url": "https://www.scadmoa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079924297740066703",
      "poi_item_slug": "scad-museum-of-art",
      "poi_latitude": "32.0775935",
      "poi_longitude": "-81.0994025",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 27 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 912-525-7191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-beb7-726e-9b9c-112b7ed2b6ba",
        "storage_key": "property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2I9T12e-4gRjx-gOb4V44s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e780e52b-8f85-4402-92f5-c75da03417bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Georgia State Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "655 Louisville Rd, Savannah, GA 31401, USA",
      "poi_short_description": "This museum offers displays of historic railcars & rolling stock, plus guided tours & train rides.",
      "poi_long_description": "This museum offers displays of historic railcars & rolling stock, plus guided tours & train rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9769-71b5-840b-9b8e3b19f96d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9769-71b5-840b-9b8e3b19f96d",
        "storage_key": "property/6767906449167579/019fbdbb-9769-71b5-840b-9b8e3b19f96d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chsgeorgia.org/GSRM",
      "poi_directions_map_url": "https://maps.google.com/?cid=9948865677916654689",
      "poi_item_slug": "georgia-state-railroad-museum",
      "poi_latitude": "32.0754846",
      "poi_longitude": "-81.1015065",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 27 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 912-651-6823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-beb7-726e-9b9c-112b7ed2b6ba",
        "storage_key": "property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55cUPUOe-4gRYUxMap94EYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c25eefe9-35b0-4185-9e79-97f8f1adf7f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Savannah Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "655 Louisville Rd, Savannah, GA 31401, USA",
      "poi_short_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_long_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-976e-700c-9c41-7c71b21f8726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-976e-700c-9c41-7c71b21f8726",
        "storage_key": "property/6767906449167579/019fbdbb-976e-700c-9c41-7c71b21f8726.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chsgeorgia.org/SCM",
      "poi_directions_map_url": "https://maps.google.com/?cid=606148658374513045",
      "poi_item_slug": "savannah-childrens-museum",
      "poi_latitude": "32.0760234",
      "poi_longitude": "-81.10093359999999",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 912-651-6823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-beb7-726e-9b9c-112b7ed2b6ba",
        "storage_key": "property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RuwSlue-4gRlRF-R_54aQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f45a11ce-0e4a-4e67-906f-609f9588697c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Telfair Academy",
      "poi_type": "Entertainment",
      "poi_address": "121 Barnard St, Savannah, GA 31401, USA",
      "poi_short_description": "Part of oldest public art museum in the South, housing 19th- & 20th-century American & European art.",
      "poi_long_description": "Part of oldest public art museum in the South, housing 19th- & 20th-century American & European art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-95f0-7028-a97d-02d429a02b9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-95f0-7028-a97d-02d429a02b9c",
        "storage_key": "property/6767906449167579/019fbdbb-95f0-7028-a97d-02d429a02b9c.webp",
        "width": 1280,
        "height": 1093
      },
      "poi_business_url": "http://www.telfair.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5508070588414779472",
      "poi_item_slug": "telfair-academy",
      "poi_latitude": "32.0789347",
      "poi_longitude": "-81.09531",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 30 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 912-790-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-beb7-726e-9b9c-112b7ed2b6ba",
        "storage_key": "property/6767906449167579/019fbdbb-beb7-726e-9b9c-112b7ed2b6ba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1g6smee-4gRUGA9ZASZcEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4803a12e-8b8a-45dd-9290-cdfdbfa06dac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Savannah Theatre",
      "poi_type": "Entertainment",
      "poi_address": "222 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_long_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-9265-73a8-a98c-9518737f74c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-9265-73a8-a98c-9518737f74c0",
        "storage_key": "property/6767906449167579/019fbdbb-9265-73a8-a98c-9518737f74c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12411390908795783721",
      "poi_item_slug": "savannah-theatre",
      "poi_latitude": "32.0758167",
      "poi_longitude": "-81.0924435",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 39 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 912-233-7764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTqMrmie-4gRKQpJ70UePqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_bd71c68c-0599-4078-a980-ba422811cc6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Port Wentworth Lion's Club Recreation Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6781 GA-21, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Community recreation park in Port Wentworth.",
      "poi_long_description": "Community recreation park in Port Wentworth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-a318-72d9-bfc1-467882849cc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-a318-72d9-bfc1-467882849cc1",
        "storage_key": "property/6767906449167579/019fbdbb-a318-72d9-bfc1-467882849cc1.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7538506570199866687",
      "poi_item_slug": "port-wentworth-lions-club-recreation-park",
      "poi_latitude": "32.1798944",
      "poi_longitude": "-81.18975929999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6550-72db-8053-c70fc8442155.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6550-72db-8053-c70fc8442155",
        "storage_key": "property/6767906449167579/019fbdb9-6550-72db-8053-c70fc8442155.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wtmhYGj-4gRPx227cgnnmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_652f59a7-7895-46f5-b2f2-a01ff36ff832",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Mobley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Port Wentworth, GA 31407, USA",
      "poi_short_description": "Public park in Port Wentworth.",
      "poi_long_description": "Public park in Port Wentworth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-a4af-76ce-b80e-d0e6da0f3726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-a4af-76ce-b80e-d0e6da0f3726",
        "storage_key": "property/6767906449167579/019fbdbb-a4af-76ce-b80e-d0e6da0f3726.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7736352640910593046",
      "poi_item_slug": "mobley-park",
      "poi_latitude": "32.1460104",
      "poi_longitude": "-81.15485319999999",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6550-72db-8053-c70fc8442155.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6550-72db-8053-c70fc8442155",
        "storage_key": "property/6767906449167579/019fbdb9-6550-72db-8053-c70fc8442155.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe9_iMQmZ-4gRFoyh6rwLXWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0ddd9329-494b-4c62-b14a-635997bf6d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Tom Triplett Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Tom Triplett Road, Pooler, GA 31322, USA",
      "poi_short_description": "Green space with tennis courts & an 18-hole disc-golf course, plus picnic pavilions & fishing piers.",
      "poi_long_description": "Green space with tennis courts & an 18-hole disc-golf course, plus picnic pavilions & fishing piers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-a1bb-756b-8328-8729144c53c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-a1bb-756b-8328-8729144c53c0",
        "storage_key": "property/6767906449167579/019fbdbb-a1bb-756b-8328-8729144c53c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/CommunityParks/TomTriplett",
      "poi_directions_map_url": "https://maps.google.com/?cid=12864486122862522763",
      "poi_item_slug": "tom-triplett-park",
      "poi_latitude": "32.0938205",
      "poi_longitude": "-81.2138926",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-447-4822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6550-72db-8053-c70fc8442155.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6550-72db-8053-c70fc8442155",
        "storage_key": "property/6767906449167579/019fbdb9-6550-72db-8053-c70fc8442155.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZN10f2g-4gRi7EpQ_jVh7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b7d21bef-7d6a-497f-9253-ddd4cf9e6ca4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Pilot Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7001 GA-21, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Roadside convenience store and fuel station offering snacks, showers, and Wi-Fi.",
      "poi_long_description": "Roadside convenience store and fuel station offering snacks, showers, and Wi-Fi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-adb1-7292-bd9f-d72e01365f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-adb1-7292-bd9f-d72e01365f1a",
        "storage_key": "property/6767906449167579/019fbdbb-adb1-7292-bd9f-d72e01365f1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.pilotflyingj.com/us/ga/port-wentworth/7001-ga-21",
      "poi_directions_map_url": "https://maps.google.com/?cid=16185788525368381093",
      "poi_item_slug": "pilot-travel-center",
      "poi_latitude": "32.1887258",
      "poi_longitude": "-81.1949602",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-964-7006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-651d-75ac-88fb-82dfa304aead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-651d-75ac-88fb-82dfa304aead",
        "storage_key": "property/6767906449167579/019fbdb9-651d-75ac-88fb-82dfa304aead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy6om9-ai-4gRpQ4taOh4n-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_18c8cc7f-4c85-4ff6-bff7-7387f31417af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Savannah/Hilton Head International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 Airways Ave, Savannah, GA 31408, USA",
      "poi_short_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_long_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-b821-75c8-804b-e37be0df5028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-b821-75c8-804b-e37be0df5028",
        "storage_key": "property/6767906449167579/019fbdbb-b821-75c8-804b-e37be0df5028.webp",
        "width": 1280,
        "height": 556
      },
      "poi_business_url": "https://savannahairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301384233227292702",
      "poi_item_slug": "savannahhilton-head-international-airport",
      "poi_latitude": "32.1294229",
      "poi_longitude": "-81.201871",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-964-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-bede-7186-9c1f-97a50b9aed5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdbb-bede-7186-9c1f-97a50b9aed5b",
        "storage_key": "property/6767906449167579/019fbdbb-bede-7186-9c1f-97a50b9aed5b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRNnApyh-4gRHpCW-Hff0C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f160c125-99b7-4aab-95a4-c463debcf4b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Amtrak Railroad Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2611 Seaboard Coastline Dr, Savannah, GA 31401, USA",
      "poi_short_description": "Savannah Amtrak station (Palmetto and Silver Meteor services along the East Coast).",
      "poi_long_description": "Savannah Amtrak station (Palmetto and Silver Meteor services along the East Coast).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-acb7-702f-aca4-ec948a65200f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-acb7-702f-aca4-ec948a65200f",
        "storage_key": "property/6767906449167579/019fbdbb-acb7-702f-aca4-ec948a65200f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3588940096901853885",
      "poi_item_slug": "amtrak-railroad-station",
      "poi_latitude": "32.0837901",
      "poi_longitude": "-81.14819109999999",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWBGZF6e-4gRvbL9ywB6zjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_3c5e5701-5340-4991-8d16-59331c53d47c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Amazon Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 Crossgate Rd, Port Wentworth, GA 31407, USA",
      "poi_short_description": "Amazon fulfillment and distribution facility near Port Wentworth; a major local employer.",
      "poi_long_description": "Amazon fulfillment and distribution facility near Port Wentworth; a major local employer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-aed4-7279-805c-677093a0e066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-aed4-7279-805c-677093a0e066",
        "storage_key": "property/6767906449167579/019fbdbb-aed4-7279-805c-677093a0e066.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2793144566542467691",
      "poi_item_slug": "amazon-distribution-center",
      "poi_latitude": "32.147158",
      "poi_longitude": "-81.1762514",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs49ynF2j-4gRa4ITPy8-wyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_52a57a2a-662d-4b1c-9e77-cb80f6dd5d2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Gulfstream Aerospace Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Gulfstream Rd, Savannah, GA 31408, USA",
      "poi_short_description": "Business-jet manufacturer headquartered at Savannah/Hilton Head International Airport; the region's largest private employer.",
      "poi_long_description": "Business-jet manufacturer headquartered at Savannah/Hilton Head International Airport; the region's largest private employer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-b13f-76d4-83b6-54f88e2d763c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-b13f-76d4-83b6-54f88e2d763c",
        "storage_key": "property/6767906449167579/019fbdbb-b13f-76d4-83b6-54f88e2d763c.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.gulfstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719559404661686851",
      "poi_item_slug": "gulfstream-aerospace-corporation",
      "poi_latitude": "32.1392172",
      "poi_longitude": "-81.1973454",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-965-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeWtFyii-4gRQ8IefUphRsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_0d4c58de-9ea1-426f-9c09-65a7c81ea0db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "poi_name": "Georgia Ports Authority - Administrative Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 Main St, Garden City, GA 31408, USA",
      "poi_short_description": "Headquarters of the Georgia Ports Authority, operator of the Port of Savannah.",
      "poi_long_description": "Headquarters of the Georgia Ports Authority, operator of the Port of Savannah.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-b001-72dc-a349-959d58aa0e69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fbdbb-b001-72dc-a349-959d58aa0e69",
        "storage_key": "property/6767906449167579/019fbdbb-b001-72dc-a349-959d58aa0e69.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gaports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3663778410647710348",
      "poi_item_slug": "georgia-ports-authority---administrative-building",
      "poi_latitude": "32.1286475",
      "poi_longitude": "-81.15145869999999",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-964-3811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fbdb9-6523-73e3-9b47-c4e59971d3bf",
        "storage_key": "property/6767906449167579/019fbdb9-6523-73e3-9b47-c4e59971d3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf78Ok-f-4gRjOpmjg1b2DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3c5745de922aecf559d8f51b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6d60b396955adfb3dcae5036",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_260e880a8b5f6f2dcbe53f9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6f5b2e84265219a23c6f0658",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_535af8ad598fed221a255ad8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a3e11ca913f262e527992f8e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "rating": "5",
      "name": "kristin Frederickson",
      "text": "I had a great experience this week.  Loved the staff. Everyone, especially Cody and his team were great. I am waiting for the perfect fit and I know they are going to be my next home!  Thanks everyone for giving me so much of your time and attention!",
      "date": "2026-06-17",
      "title": "false"
    },
    {
      "id": "ec_3bbbb76bf025ae8ca3122470",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "rating": "5",
      "name": "shadiqua gadson",
      "text": "Love love love ❤️ My home, my neighborhood, my neighbors and everything that comes with it. Very family oriented my children are at peace. The management: Kaily, Gabriel, Blake, very professional, friendly, upfront and communicative. They add to the comfortability of our home by being there when we need them.",
      "date": "2025-12-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_945b1209-f6fd-4c77-8ecd-5ea7f0f86c40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Brunswick home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Brunswick",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iJXDrTes3fg"
    },
    {
      "id": "custom_bb94a836-3382-47fc-ab32-59be982685aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Guilford home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Guilford",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dunXUhvCdpG"
    },
    {
      "id": "custom_60bdbdb9-c87a-4883-80c3-6099dd9fa1d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Chatham home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Chatham",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9ZXEyxqPnQF"
    },
    {
      "id": "custom_150f25de-edb6-4beb-a4f5-2ab838afd8d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the McDowell home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "McDowell",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wDi3mK26of1"
    },
    {
      "id": "custom_03a82c05-cf76-41c9-abf8-946b815d2474",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Pickens home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Pickens",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7GYCzfF3XEq"
    },
    {
      "id": "custom_a1d5f99d-d5c4-4683-be63-ba23978aa1fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Durham home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Durham",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tHCuab688qf"
    }
  ],
  "faqs": [
    {
      "id": "custom_2fa3387e-18c3-4403-8210-8aa59cb3d607",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_d6d893cf-2924-44d1-8130-67872468ca5e",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_34434b10-9b7c-47a8-b630-fe9145207c4f",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_21fc0c3f-1537-42ab-932c-5d6c13afb17d",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_fb6c222d-c214-466b-8b69-6fc682dec2fa",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_fa0b10c6-8d49-49ab-ab4c-329764266c96",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_fa2ce017-ca32-4fbd-b976-77400f529acd",
      "question": "Landscape Services",
      "answer": "Single-family homes: $95/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_16421a98-ef27-431a-973a-2a9b9e32e663",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_0a87232a-030c-4699-bd18-f05962afb697",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_17dc0a46-719f-46d9-bd8b-cf5be62f0ed5",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_c063fe17-b807-4f99-8c63-47aa75ba3179",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_53d36bc6-f267-4585-b861-d6bee93fbd92",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_d6e09cfd-8075-4c16-afe7-3aa528ebe482",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_e9dddd16-98c5-45e4-9444-15a513638ff0",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_53e8cb71-2ce4-4d60-a528-0b582c474181",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_1a472a5b-1fae-426a-aacb-23b12c17b4e6",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_747a11fb-14ec-4720-a534-f89b902818b5",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_5ec21f45-a0be-4846-a752-0bd2117e0b44",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_31aa375d-fbec-4788-9111-105e2d1c4944",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_3c05e602c81a7690b41a8fed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "yardi",
      "external_id": "2355437",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-9a05-7799-a275-f906ceb8e2a0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Mulberry at Rice Hope Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579"
    },
    {
      "lead_collector_id": "01a0abe0-9a88-7718-b29c-5e8fa05fccf8",
      "lead_source": "LANDING_PAGE",
      "name": "Mulberry at Rice Hope Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-port-wentworth-ga",
      "search_query": "apartments with in-unit laundry Port Wentworth GA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Explore top apartments with in-unit laundry right here in Port Wentworth, GA. Discover your new home at Mulberry at Rice Hope today.",
      "page_copy": "Looking for apartments with in-unit laundry in Port Wentworth, GA? Mulberry at Rice Hope offers just what you need along with a host of other luxurious amenities. Each of our thoughtfully designed units includes spacious closets and high-end finishes like granite countertops and stainless steel appliances.\n\nLocated in the charming Chatham County, our community provides a serene setting complete with a resort-style pool for relaxation. The convenience of in-unit laundry means you can enjoy more of what you love without the hassle. Discover the perfect blend of comfort and luxury at Mulberry at Rice Hope today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Port Wentworth, GA",
      "seo_description": "Discover Mulberry at Rice Hope's top choice apartments with in-unit laundry in Port Wentworth, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-chatham-county",
      "search_query": "resort style pool apartments Chatham County",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments",
      "h2_subtitle": "Find out why resort style pool apartments in Chatham County are the ultimate choice. Dive into luxury at Mulberry at Rice Hope.",
      "page_copy": "Escape to your personal oasis at Mulberry at Rice Hope, premier resort style pool apartments in Chatham County. Our community boasts an exquisite pool area that rivals any tropical resort, offering residents the perfect spot for relaxation and recreation.\n\nBeyond the stunning pool, each apartment features modern conveniences like in-unit laundry, granite countertops, and stainless steel appliances. Located in Port Wentworth, our community enjoys a peaceful setting, yet remains close to all that Chatham County has to offer. Embrace the lifestyle you've always dreamed of at Mulberry at Rice Hope.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments in Chatham County",
      "seo_description": "Experience luxury living with a resort style pool at Mulberry at Rice Hope, Chatham County's finest apartment community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "lazy-river-apartments-near-31407",
      "search_query": "lazy river apartments near 31407",
      "category": "Amenity",
      "h1_title": "Explore Lazy River Apartments",
      "h2_subtitle": "Searching for lazy river apartments near 31407? Experience unparalleled leisure at Mulberry at Rice Hope.",
      "page_copy": "Imagine immersing yourself in the ultimate relaxation surrounded by beautiful amenities at Mulberry at Rice Hope, where lazy river-inspired leisure is just minutes away from the 31407 area. Although we feature a stunning resort-style pool, our community also emphasizes convenient and luxurious living with in-unit laundry, state-of-the-art stainless steel appliances, and elegant granite countertops.\n\nLocated in Port Wentworth within Chatham County, our apartment homes promise spacious living with ample closet space and a host of modern features. While we may not have a formal lazy river, the tranquil environment and top-notch facilities set the perfect backdrop for a leisurely lifestyle. Choose Mulberry at Rice Hope for a well-rounded, relaxing living experience near 31407.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lazy River Apartments Near 31407",
      "seo_description": "Discover leisure-filled living near 31407 at Mulberry at Rice Hope, where luxury and convenience seamlessly blend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "luxury-apartments-gym-port-wentworth",
      "search_query": "luxury apartments with gym Port Wentworth",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Gym Access",
      "h2_subtitle": "Discover luxury apartments with a gym in Port Wentworth. Mulberry at Rice Hope offers the ultimate fitness-friendly lifestyle.",
      "page_copy": "Looking for luxury apartments with gym access in Port Wentworth? Mulberry at Rice Hope not only provides sophisticated living spaces but also includes a fully-equipped gym for residents who prioritize an active lifestyle. Our apartments come with high-end finishes such as stainless steel appliances, granite countertops, and spacious closets, offering the perfect blend of style and functionality.\n\nLocated in the serene setting of Chatham County, our community also features a resort-style pool and convenient in-unit laundry, ensuring every aspect of daily living is catered for. Choose Mulberry at Rice Hope and enjoy a luxurious lifestyle paired with excellent fitness amenities in the heart of Port Wentworth.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Gym in Port Wentworth",
      "seo_description": "Experience the perfect balance of luxury and fitness at Mulberry at Rice Hope, offering premium apartments with gym access in Port Wentworth.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "smart-home-apartments-ga",
      "search_query": "smart home technology apartments in GA",
      "category": "Amenity",
      "h1_title": "Smart Home Technology Apartments in GA",
      "h2_subtitle": "Explore smart home technology apartments in GA at Mulberry at Rice Hope. Experience cutting-edge living with top amenities.",
      "page_copy": "Discover the future of living at Mulberry at Rice Hope, where smart home technology meets modern design in the heart of Georgia. Our apartments provide residents with enhanced convenience and control, paired with luxury features such as stainless steel appliances, granite countertops, and spacious closets.\n\nConveniently located in Port Wentworth within Chatham County, we offer an innovative living experience that seamlessly integrates technology into everyday life. With additional amenities like a resort-style pool and in-unit laundry, Mulberry at Rice Hope sets the standard for sophisticated, tech-enabled living in GA. Upgrade your lifestyle and join a community that embraces smart home technology.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Technology Apartments in GA",
      "seo_description": "Mulberry at Rice Hope offers smart home technology apartments in GA, blending innovation with luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-port-wentworth-ga",
      "search_query": "four bedroom apartments port wentworth ga",
      "category": "Floorplan",
      "h1_title": "Spacious Four Bedroom Apartments in Port Wentworth",
      "h2_subtitle": "Looking for four bedroom apartments in Port Wentworth, GA? Discover ample living at Mulberry at Rice Hope.",
      "page_copy": "Explore expansive living options at Mulberry at Rice Hope with our four bedroom apartments in Port Wentworth, GA. Our community is designed to cater to those needing extra space without compromising on style and comfort. Each apartment is equipped with top-tier stainless steel appliances, sleek granite countertops, and abundant storage in our spacious closets.\n\nLocated in the welcoming environment of Chatham County, residents enjoy easy access to a resort-style pool and in-unit laundry facilities, ensuring both relaxation and convenience. Whether you're accommodating a growing family or seeking additional room for home office needs, Mulberry at Rice Hope offers the ideal setting for all your lifestyle needs in Port Wentworth.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Port Wentworth, GA",
      "seo_description": "Discover spacious four bedroom apartments in Port Wentworth, GA at Mulberry at Rice Hope, offering luxury and comfort for any lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-chatham-county",
      "search_query": "three bedroom apartments chatham county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Chatham County",
      "h2_subtitle": "Searching for three bedroom apartments in Chatham County? Mulberry at Rice Hope offers spacious and stylish living options for all types of families.",
      "page_copy": "Mulberry at Rice Hope provides the perfect solution for those seeking three bedroom apartments in Chatham County. Our community combines elegance and functionality, offering spacious layouts adorned with modern touches. Each apartment features stainless steel appliances, granite countertops, and roomy closets, ensuring a stylish and comfortable home.\n\nNestled in the scenic locale of Port Wentworth, residents enjoy amenities like a resort-style pool and the convenience of in-unit laundry. Whether you have a growing family or simply desire more space, our three bedroom floor plans provide the ideal environment for both relaxation and entertainment. Experience refined living at Mulberry at Rice Hope in Chatham County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Chatham County",
      "seo_description": "Discover three bedroom apartments at Mulberry at Rice Hope in Chatham County, offering modern designs and ample space for every lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "apartments-near-georgia-tech-savannah",
      "search_query": "apartments near Georgia Tech Savannah Chatham County",
      "category": "School",
      "h1_title": "Apartments Near Georgia Tech Savannah",
      "h2_subtitle": "Find convenient apartments near Georgia Tech Savannah in Chatham County. Mulberry at Rice Hope offers comfortable living options for students and families alike.",
      "page_copy": "Situated in the vibrant community of Chatham County, Mulberry at Rice Hope offers ideal apartments near Georgia Tech Savannah. Perfect for students, faculty, and tech professionals, our location allows easy access to campus life while providing a serene retreat. Enjoy modern comforts with stainless steel appliances, granite countertops, and expansive closets in every unit.\n\nIn addition to proximity to Georgia Tech Savannah, Mulberry at Rice Hope boasts premium amenities such as a resort-style pool and in-unit laundry facilities. Experience the best of both worlds with our seamless blend of convenience and luxury, making our community the perfect choice for those studying or working at Georgia Tech Savannah.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Tech Savannah",
      "seo_description": "Mulberry at Rice Hope offers convenient apartment living near Georgia Tech Savannah in Chatham County, blending modern amenities with prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "apartments-near-mccall-park-port-wentworth",
      "search_query": "apartments near McCall Park Port Wentworth",
      "category": "Park",
      "h1_title": "Apartments Near McCall Park in Port Wentworth",
      "h2_subtitle": "Discover comfortable living with our apartments near McCall Park in Port Wentworth. Mulberry at Rice Hope offers modern amenities and convenient location.",
      "page_copy": "Enjoy the convenience of residing in our apartments near McCall Park in Port Wentworth at Mulberry at Rice Hope. Our community provides easy access to this beautiful outdoor space, perfect for leisure and recreation. Each apartment is thoughtfully designed with stainless steel appliances, granite countertops, and spacious closets, ensuring you have both style and convenience.\n\nLocated in the vibrant Port Wentworth area, our residents benefit from a rich roster of amenities, including a resort-style pool and in-unit laundry. Whether you're a young professional, family, or retiree, Mulberry at Rice Hope offers the perfect blend of tranquility and modern living just steps from McCall Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McCall Park Port Wentworth",
      "seo_description": "Find your perfect home at Mulberry at Rice Hope with apartments near McCall Park in Port Wentworth, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167579",
      "source": "generator",
      "page_item_url": "mulberry-at-rice-hope-near-freedom-park",
      "search_query": "Mulberry at Rice Hope apartments close to Freedom Park Chatham County",
      "category": "Park",
      "h1_title": "Mulberry at Rice Hope Near Freedom Park",
      "h2_subtitle": "Explore Mulberry at Rice Hope apartments, conveniently close to Freedom Park in Chatham County, where modern living meets natural beauty.",
      "page_copy": "At Mulberry at Rice Hope, experience the perfect combination of modern living and natural beauty in our apartments close to Freedom Park in Chatham County. Our location offers residents the ideal blend of urban convenience and outdoor recreation. With granite countertops, stainless steel appliances, and spacious closets, each apartment is designed with comfort and elegance in mind.\n\nJust a short distance from the serene landscapes of Freedom Park, residents enjoy easy access to outdoor activities and relaxation. Mulberry at Rice Hope also features a resort-style pool and in-unit laundry, embodying luxury and convenience. Discover your new home where every day brings opportunities for adventure and tranquility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mulberry at Rice Hope Near Freedom Park",
      "seo_description": "Discover modern living at Mulberry at Rice Hope, with apartments close to Freedom Park in Chatham County, offering convenience and stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977269404"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KV5K8QL7"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57160263277"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwn5nm5wd2"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/4b38ef11-3163-4786-b84a-be8e0dedabe2/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f5761766-ff93-11ef-945d-3f223fe36235"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-791-0725"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "877-311-9556"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977269404",
  "custom_google_gtm_id": "GTM-KV5K8QL7",
  "custom_rollout_phase": "Phase 1",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57160263277",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwn5nm5wd2",
  "custom_self_guided_tour_url": "https://selftournow.com/property/4b38ef11-3163-4786-b84a-be8e0dedabe2/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f5761766-ff93-11ef-945d-3f223fe36235",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "855-791-0725",
  "custom_paid_social_tracking_phone_number": "877-311-9556",
  "custom_audioeye_site_id": "f14cdacf-6c5b-4ad3-975e-e77a653a9a09",
  "custom_audioeye_site_hash": "fbf94524f241c6c7d25b7f4e15794d77"
};

export const generatedAt = '2026-10-29T18:34:49.224Z';
